'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

require('./Badge.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Badge = function (_Component) {
  _inherits(Badge, _Component);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          children = _props.children,
          color = _props.color,
          full = _props.full,
          onClick = _props.onClick,
          o = _props.opacity,
          rest = _objectWithoutProperties(_props, ['children', 'color', 'full', 'onClick', 'opacity']);

      var isFaded = color === 'faded';
      var textColor = isFaded || o < 1 ? undefined : 'night';
      var opacity = isFaded || o < 1 ? Math.max(.1, Math.min(isFaded ? .3 : .6, o)) : 1;
      var style = { opacity: opacity };
      var classes = (0, _classnames3.default)('ax-badge', (_classnames = {}, _defineProperty(_classnames, 'ax-badge--' + color, color), _defineProperty(_classnames, 'ax-badge--clickable', onClick), _defineProperty(_classnames, 'ax-badge--full', full === true), _defineProperty(_classnames, 'ax-badge--full--' + full, typeof full === 'string'), _classnames));

      return _react2.default.createElement(
        _Base2.default,
        _extends({}, rest, { Component: 'span', className: classes, onClick: onClick, textColor: textColor }),
        _react2.default.createElement('span', { className: 'ax-badge__background', style: style }),
        _react2.default.createElement(
          'span',
          { className: 'ax-badge__content' },
          children
        )
      );
    }
  }]);

  return Badge;
}(_react.Component);

Badge.propTypes = {
  /** Content to appear inside the Badge */
  children: _propTypes2.default.node,
  /** Colour of the Badge */
  color: _propTypes2.default.oneOf(['faded', 'highlight', 'success', 'error', 'forbidden-planet', 'tiny-clanger', 'critical-mass', 'fantastic-voyage', 'paradise-lost', 'serene-sea', 'event-horizon', 'electric-dreams', 'outer-limits', 'giant-leap', 'moon-lagoon', 'space-invader', 'extraterrestrial', 'terra-form', 'primeval-soup', 'future-shock', 'sun-maker', 'new-horizon', 'blast-off', 'crash-course', 'solar-rust', 'ground-control', 'space-oddity', 'rocky-planet', 'deep-thought', 'luna-dust']).isRequired,
  /**
   * Controls the full width appearance of the badge either all of the time,
   * with a value of `true` otherwise at one of the breakpoints specified.
   */
  full: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /** Click handler that applied clickable styling */
  onClick: _propTypes2.default.func,
  /** The opacity of the background of the Badge */
  opacity: _propTypes2.default.number
};
Badge.defaultProps = {
  color: 'faded',
  opacity: 1
};
exports.default = Badge;